"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Zap, Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const teamData = [{
  name: "Jeff Dillman",
  position: "Managing Partner",
  bio: "Expert in sell-side M&A and private equity with 20 years of institutional experience.",
  style: "Strategic Integrity",
  icon: Zap,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657590/img/founder_marcus_sterling.png"
}];
function TeamMemberCard({
  member,
  index
}: {
  member: typeof teamData[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const Icon = member.icon;
  return <div data-index={index} ref={ref} className={cn("transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12", index === 1 && "delay-150")}>
      <Card className="relative overflow-hidden group aspect-[3/4] bg-card/40 border-border/40 hover:border-primary/60 transition-colors duration-500 p-0 flex flex-col justify-end shadow-xl">
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-background/40 to-background z-10 pointer-events-none" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,var(--color-primary)_0%,transparent_50%)] opacity-5 group-hover:opacity-10 transition-opacity duration-700 pointer-events-none" />
        
        {}
        <div className="absolute inset-0 z-0 flex items-start justify-center pt-8">
           <SafeHydrate><Avatar className="size-48 sm:size-56 border-4 border-white/80 shadow-2xl shadow-primary/5 transition-transform duration-700 group-hover:scale-105 group-hover:shadow-primary/10 rounded-none">
            <AvatarImage src={member.image} alt={member.name} className="object-cover" />
            <AvatarFallback className="bg-muted text-muted-foreground text-4xl font-default font-bold">
              {member.name.split(' ').map(n => n[0]).join('')}
            </AvatarFallback>
          </Avatar></SafeHydrate>
        </div>

        {}
        <CardContent className="relative z-20 flex flex-col items-center justify-end h-full pb-8 px-6 text-center">
          <h3 className="text-2xl sm:text-3xl font-bold font-default text-primary tracking-tight mb-1">
            {member.name}
          </h3>
          <p className="text-muted-foreground font-mono uppercase tracking-widest text-xs sm:text-sm mb-4">
            {member.position}
          </p>
          
          {}
          <div className="h-8 overflow-hidden flex items-end justify-center w-full">
            <div className="translate-y-full opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-400 ease-out flex items-center">
              <Badge variant="outline" className="border-primary-foreground/30 bg-white/90 backdrop-blur-md text-primary-foreground gap-1.5 py-1 px-3 shadow-lg shadow-primary/5 rounded-none">
                <Icon className="size-3.5" />
                <span className="font-mono text-[10px] uppercase tracking-wider">{member.style}</span>
              </Badge>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>;
}
export default function TheEditingTeam() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return;
}